export function removeLoadingSVG() {
  const svg = document.querySelector('.app-loading-container')! as HTMLElement
  svg.style.opacity = '0'
  window.setTimeout(() => svg.remove(), 300)
}

export function formatNumber(value: number | string, decimals: number): number {
  const num = Number(value);
  if (isNaN(num)) {
    return 0;
  }
  return Number(num.toFixed(decimals));
}